import React, { useState } from "react"
import { css, useTheme } from "@emotion/react"
import { Flex, Image } from "rebass"
import { AuthWrapper } from "./user-info/AuthWrapper"
import { routes } from "../../routes"
import { useI18next } from "gatsby-plugin-react-i18next"
import { ButtonSecondary } from "../button/buttons"
import { CartSizeIndicator } from "../delivery/CartSizeIndicator"
import { mobileContainer } from "../../theme"
import { LogInModal } from "./user-info/log-in/LogInModal"
import { ForgotPasswordModal } from "./user-info/log-in/ForgotPasswordModal"
import { SignUpModal } from "./user-info/sign-up/SignUpModal"
import { ConfirmCodeModal } from "./user-info/sign-up/ConfirmCodeModal"
import { SignUpFormType } from "../../models/sign-up-form"

type Props = {
  countryCode?: string
  hideAuth?: boolean
  showCheckoutButton?: boolean
  cartLength?: number
  setCartVisible?: React.Dispatch<React.SetStateAction<boolean>>
}

const imageStyle = css`
  width: 100px;
  max-height: 30px;
  cursor: pointer;
`

const Logo = process.env.GATSBY_LOGO || ""

export const Header = ({
  hideAuth,
  countryCode,
  showCheckoutButton,
  cartLength = 0,
  setCartVisible,
}: Props) => {
  const theme = useTheme()
  const { navigate } = useI18next()

  const [signUpData, setSignUpData] = useState<SignUpFormType>()
  const [signUpError, setSignUpError] = useState<string>()

  const wrapperStyle = css`
    width: 100%;
    justify-content: center;
    border-bottom: 1px solid ${theme.colors.dividerLight};

    ${theme.bp.mobile} {
      position: sticky;
      top: -1px;
      z-index: 1001;
    }
  `

  const innerWrapperStyle = css`
    background-color: ${theme.colors.white};
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    padding-top: 16px;
    padding-bottom: 16px;
    align-items: center;

    ${theme.bp.desktop} {
      display: flex;
      padding-left: 100px;
      padding-right: 100px;
      max-width: 1300px;
    }
    ${theme.bp.mobile} {
      padding-left: 16px;
      padding-right: 16px;
      height: 93px;
    }
  `

  const checkoutButtonStyle = css`
    ${mobileContainer}
  `

  const userInfoStyle = css`
    ${theme.bp.mobile} {
      display: ${showCheckoutButton ? "none" : "flex"};
    }
  `

  return (
    <Flex css={wrapperStyle}>
      <Flex css={innerWrapperStyle}>
        <Image
          onClick={() => {
            navigate(routes.restaurants(countryCode))
          }}
          src={Logo}
          css={imageStyle}
        />
        {!hideAuth && (
          <AuthWrapper
            countryCode={countryCode}
            additionalCss={userInfoStyle}
          />
        )}
        {showCheckoutButton && setCartVisible && (
          <ButtonSecondary
            css={checkoutButtonStyle}
            className="cart-button-mobile" // For datadog testing
            backgroundColor={theme.colors.ctaMain}
            hoverColor={theme.colors.ctaSecondaryOne}
            color={theme.colors.white}
            width="160px"
            onClick={() => {
              if (setCartVisible) {
                setCartVisible(true)
              }
            }}
            leftComponent="Checkout"
            rightComponent={<CartSizeIndicator>{cartLength}</CartSizeIndicator>}
          />
        )}
        <LogInModal />
        <ForgotPasswordModal />
        <SignUpModal
          setSignUpError={setSignUpError}
          signUpError={signUpError}
          setSignUpData={setSignUpData}
          countryCode={countryCode}
        />
        {signUpData && (
          <ConfirmCodeModal
            signUpData={signUpData}
            setSignUpError={setSignUpError}
          />
        )}
      </Flex>
    </Flex>
  )
}
